// * [TYPES] Discrete Scroll-Locked Canvas Sequence Engine
// ? Strict typing for frame checkpoints, section descriptors, and telemetry

export interface SectionItem {
  readonly id: string;
  readonly title: string;
  readonly subtitle: string;
}

export interface FrameTrackState {
  frame: number;
}

export interface TelemetryState {
  readonly currentSectionIndex: number;
  readonly totalSections: number;
  readonly currentFrame: number;
}

export interface ScrollLockedAvianSequenceProps {
  readonly onSectionChange?: (index: number) => void;
  readonly className?: string;
}

// * Exact frame checkpoints mapping to 5 core sections
export const SECTION_CHECKPOINTS = [0, 50, 100, 150, 200] as const;

export const TOTAL_FRAMES = 201;

export const TRANSITION_DURATION = 1.15;

export const COOLDOWN_DURATION_MS = 250;

export const DEFAULT_SECTIONS: readonly SectionItem[] = [
  { id: 'hero', title: 'Hero Section', subtitle: 'Autonomous Flight Initialized' },
  { id: 'about', title: 'About', subtitle: 'Architectural Overview & Direction' },
  { id: 'projects', title: 'Featured Projects', subtitle: 'Horizontal Systems Runway' },
  { id: 'experience', title: 'Experience', subtitle: 'Chronological Engineering Ledger' },
  { id: 'achievements', title: 'Achievements', subtitle: 'Verified Credentials & Telemetry' },
] as const;

export const SECTION_LABELS = [
  'Home',
  'About Me',
  'Projects',
  'Experience',
  'Achievements',
] as const;

